import React from "react";
import { AboutSection } from "../courses/commoncomponents";
import { eamcetCourse, homeImages, studentsRanks } from "../data";

/**
 * Rankridge EAMCET (EAPCET) Long‑Term Coaching – Landing Page
 * Tech: React + Tailwind CSS (no external UI libs)
 *
 * How to use
 * 1) Drop this file as `EamcetLongTerm.jsx` and import in your router/page.
 * 2) Make sure Tailwind is set up (typography optional). Works standalone.
 * 3) Replace placeholder images (unsplash) with your assets.
 */


const aboutTitle='About Rankridge EAMCET Long-Term Coaching'
const aboutDescription=`Rankridge College is one of Hyderabad’s most trusted names in EAMCET (EAPCET) long-term coaching, helping students secure admission into top Engineering, Agriculture, and Pharmacy colleges across Telangana and Andhra Pradesh. With faculty who specialize in Physics, Chemistry, and Mathematics/Biology, our programs ensure that every student masters concepts, builds speed, and develops exam-ready confidence.
Our proven track record includes top 100 and top 500 ranks year after year, with students placed in leading government and private institutions. The secret to this success lies in small batch sizes, customized study material, daily practice papers, and regular mock tests that simulate real exam conditions.
` 
const description2='' 

export default function EamcetLongTerm() {
  return (
    <main className="bg-white text-neutral-900">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 -z-10 bg-gradient-to-b from-emerald-50 via-white to-white"/>
        <div className="absolute -top-24 -right-24 h-[420px] w-[420px] rounded-full bg-emerald-200/40 blur-3xl"/>
        <div className="absolute -bottom-28 -left-20 h-[360px] w-[360px] rounded-full bg-teal-200/40 blur-3xl"/>

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-1 pb-1 lg:pt-2 lg:pb-16 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-emerald-100 px-3 py-1 text-sm font-semibold text-emerald-800 ring-1 ring-emerald-200">
              <span className="h-2 w-2 rounded-full bg-emerald-500"/> Admissions Open – 2025 (Limited Seats)
            </span>
            <h1 className="mt-5 text-3xl sm:text-3xl lg:text-3xl font-extrabold leading-tight tracking-tight">
              Best EAMCET (EAPCET) Long‑Term Coaching in Hyderabad
            </h1>
            <p className="mt-5 text-lg text-neutral-700 leading-relaxed">
              Your trusted destination for EAMCET success. With expert faculty, world‑class facilities, and
              a proven system, Rankridge turns consistent effort into top ranks for Engineering, Agriculture
              and Pharmacy aspirants in Telangana & Andhra Pradesh.
            </p>

            {/* Hero CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a href="tel:+919959271353" className="inline-flex items-center justify-center rounded-2xl bg-emerald-600 px-6 py-3 text-white font-semibold shadow hover:bg-emerald-700 active:scale-[0.99]">
                Call: +91 99 59 271 353
              </a>
              <a href="https://www.rankridge.com/contact-us/" target="_blank" rel="noreferrer" className="inline-flex items-center justify-center rounded-2xl bg-white px-6 py-3 font-semibold text-emerald-700 ring-1 ring-emerald-200 hover:ring-emerald-400">
                 Enquiry For Admissions
              </a>
            </div>




            {/* Trust bar */}
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
              {["Top 100/500 Ranks","TS & AP Focus","DPP + Grand Tests","Hostel & Care"].map((t)=> (
                <div key={t} className="rounded-2xl bg-neutral-50 ring-1 ring-neutral-200 p-3 sm:p-4">
                  <p className="text-sm font-medium text-neutral-700">{t}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Hero Media */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-3xl ring-1 ring-neutral-200 overflow-hidden shadow-lg">
              <img
                src={eamcetCourse[1]}
                alt="Digital classroom at Rankridge"
                className="rounded-2xl"
                loading="eager"
                fetchPriority="high"
                decoding="async"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 hidden md:block w-40 rounded-2xl bg-white p-3 ring-1 ring-neutral-200 shadow-lg">
              <p className="text-xs font-semibold text-neutral-600">Bilingual Teaching</p>
              <p className="text-sm">English + Telugu</p>
            </div>
          </div>
        </div>
      </section>


<section>
  <AboutSection title={aboutTitle} description={aboutDescription} description2={description2} imagePath={eamcetCourse[0]}   />
  
</section>

      {/* WHY CHOOSE */}
      <section className="py-2 sm:py-2 text-center mt-4 bg-[#20b2aa]">
        <div className="  px-4 sm:px-6 lg:px-3">
          <div className="">
            <h2 className="text-3xl sm:text-4xl font-extrabold">Why Choose Rankridge for EAMCET Long‑Term?</h2>
            <p className="mt-4 text-neutral-700">
              Expert mentors, powerful study modules, and relentless practice—crafted for the latest EAMCET/EAPCET pattern with separate strategies for TS & AP.
            </p>
          </div>

          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                title:"Expert Faculty with Subject Mastery",
                desc:"Physics, Chemistry, Mathematics/Biology mentors with 1‑on‑1 doubt clearing, speed & confidence building.",
                icon: FacultyIcon
              },
              {
                title:"Powerful Study Material & DPPs",
                desc:"Exclusive Rankridge modules, chapter‑wise MCQs, model papers, revision schedules for TS & AP.",
                icon: BookIcon
              },
              {
                title:"Special Focus on Physics & Chemistry",
                desc:"Tough concepts simplified with real‑world examples and frequent mocks for accuracy & speed.",
                icon: AtomIcon
              },
              {
                title:"Proven Track Record",
                desc:"Consistent Top‑100 & Top‑500 ranks, seats in government colleges—results that speak.",
                icon: TrophyIcon
              },
              {
                title:"World‑Class Learning Environment",
                desc:"AC digital classrooms, smartboards, interactive teaching, performance tracking & PTMs.",
                icon: ClassroomIcon
              },
              {
                title:"Best Hostel & Residential Care",
                desc:"Safe hostels, nutritious food, monitored study rooms, parent communication & wellness.",
                icon: HostelIcon
              },
            ].map((f)=> (
              <FeatureCard key={f.title} {...f}/>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES → BENEFITS TABLE */}
      <section className="py-16 bg-neutral-50 text-center">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="">
            <h2 className="text-3xl sm:text-4xl font-extrabold">Features & Benefits</h2>
            <p className="mt-4 text-neutral-700">What makes our EAMCET preparation effective—every single day.</p>
          </div>

          <div className="mt-8 overflow-hidden rounded-2xl ring-1 ring-neutral-200 bg-white">
            <div className="hidden md:grid grid-cols-2 bg-neutral-50 py-3 px-4 text-sm font-semibold text-neutral-700">
              <div>Features</div>
              <div>Benefits</div>
            </div>
            <ul className="divide-y divide-neutral-200">
              {[
                ["IIT/NEET faculty for EAMCET Physics & Chemistry","Strong conceptual foundation"],
                ["Regular Grand Tests","Builds exam temperament & time management"],
                ["Chapter‑wise Revision Schedules","Targeted preparation & retention"],
                ["Mentor Support","Personalized guidance & motivation"],
                ["Bilingual Teaching (English + Telugu)","Better comprehension & accessibility"],
                ["Focus on Application‑Based Questions","Real exam‑level practice"],
              ].map(([a,b])=> (
                <li key={a} className="grid md:grid-cols-2 ">
                  <div className="p-4">
                    <p className="font-medium">{a}</p>
                  </div>
                  <div className="p-4 bg-neutral-50/70 md:bg-transparent">
                    <p className="text-neutral-700">{b}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* BEYOND ACADEMICS */}
      {/* <section className="py-1">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-1 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl sm:text-4xl font-extrabold">Beyond Academics – Building Strong Futures</h2>
            <ul className="mt-6 space-y-3 text-neutral-700">
              {[
                "Discipline & time‑management training",
                "Motivational sessions & mental wellness programs",
                "Career guidance for Engineering, Pharmacy & Agriculture",
                "Transparent monthly reports for parents",
              ].map((t)=> (
                <li key={t} className="flex items-start gap-3"><CheckIcon className="mt-1"/> <span>{t}</span></li>
              ))}
            </ul>
          </div>
          <div className="order-1 lg:order-2">
            <div className="aspect-[16/10] rounded-3xl overflow-hidden ring-1 ring-neutral-200 shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?q=80&w=1600&auto=format&fit=crop"
                alt="Mentor guidance and group study"
                className="h-full w-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </section> */}

      {/* TS vs AP STRATEGY CALLOUT */}
      <section className="py-14 bg-gradient-to-r from-emerald-600 to-teal-600">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-white">
          <div className="grid lg:grid-cols-3 gap-8 items-center">
            <div className="lg:col-span-2">
              <h3 className="text-2xl sm:text-3xl font-extrabold">Separate Strategies for TS EAMCET & AP EAPCET</h3>
              <p className="mt-3 text-emerald-100">Pattern‑aware modules, state‑specific mocks, and rank‑benchmarking to maximise your score.</p>
            </div>
            <div className="flex gap-3">
              <a href="#apply" className="flex-1 text-center rounded-2xl bg-white/95 px-5 py-3 font-semibold text-emerald-700 shadow">Apply Now</a>
              <a href="tel:+919959271353" className="flex-1 text-center rounded-2xl border border-white/60 px-5 py-3 font-semibold text-white">Call Us</a>
            </div>
          </div>
        </div>
      </section>

      {/* RESULTS STRIP */}
      <section className="py-14">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-extrabold">Proven Track Record of Results</h2>
          <div className="mt-1 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              ["Top 100/500 Ranks","Consistent performers"],
              ["Government Seats","Engineering & Pharmacy"],
              ["Grand Tests","Weekly benchmarking"],
              ["DPP + Revisions","Daily improvement"],
            ].map(([k,v])=> (
              <div key={k} className="rounded-2xl ring-1 ring-neutral-200 bg-white p-5 shadow-sm">
                <p className="text-lg font-bold">{k}</p>
                <p className="text-neutral-600">{v}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-1 bg-neutral-50" id="faq">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-center">FAQs</h2>
          <div className="mt-8 space-y-4">
            {[
              ["Is teaching bilingual?", "Yes. We teach in English + Telugu for better comprehension."],
              ["Are there hostel facilities?", "Yes. Safe residential care, monitored study hours, and nutritious meals."],
              ["Do you conduct regular mocks?", "Weekly grand tests + chapter tests with rank benchmarking and detailed feedback."],
              ["How do parents track progress?", "Monthly reports and mentor connect ensure transparent feedback."],
            ].map(([q,a])=> (
              <details key={q} className="group rounded-2xl bg-white p-5 ring-1 ring-neutral-200 open:ring-emerald-200">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4">
                  <span className="font-semibold">{q}</span>
                  <span className="transition-transform group-open:rotate-45 text-neutral-500">✚</span>
                </summary>
                <p className="mt-3 text-neutral-700">{a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT / APPLY */}
      <section id="apply" className="py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="rounded-3xl bg-gradient-to-r from-emerald-50 to-teal-50 ring-1 ring-emerald-200 p-6 sm:p-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl sm:text-3xl font-extrabold">Join Rankridge – Hyderabad’s Most Trusted EAMCET Coaching</h3>
              {/* <p className="mt-3 text-neutral-700 max-w-2xl">Expert faculty, personalised mentoring, and a proven system. Apply now to secure your seat for 2025.</p> */}
            </div>
            <div className="flex w-full sm:w-auto flex-col sm:flex-row gap-3">
              <a href="tel:+919959271353" className="inline-flex items-center justify-center rounded-2xl bg-emerald-600 px-6 py-3 text-white font-semibold shadow hover:bg-emerald-700">Call: +91 99 59 271 353</a>
              {/* <a href="https://www.rankridge.com" target="_blank" rel="noreferrer" className="inline-flex items-center justify-center rounded-2xl bg-white px-6 py-3 font-semibold text-emerald-700 ring-1 ring-emerald-200 hover:ring-emerald-400">Visit Website</a> */}
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER MINI */}
      <footer className="pb-10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center text-sm text-neutral-500">
          © {new Date().getFullYear()} Rankridge College • EAMCET (EAPCET) Long‑Term Coaching • Hyderabad
        </div>
      </footer>
    </main>
  );
}

/* ——— UI Primitives ——— */
function FeatureCard({title, desc, icon:Icon}){
  return (
    <div className="rounded-3xl ring-1 ring-neutral-200 bg-white p-6 shadow-sm hover:shadow-md transition">
      <div className="flex items-start gap-4">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-100 ring-1 ring-emerald-200">
          <Icon/>
        </span>
        <div>
          <h3 className="font-semibold text-lg">{title}</h3>
          <p className="mt-1 text-neutral-700">{desc}</p>
        </div>
      </div>
    </div>
  );
}

function CheckIcon(props){
  return (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" className="h-5 w-5 stroke-emerald-600" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
    </svg>
  );
}
function FacultyIcon(){
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6 stroke-emerald-700" strokeWidth="1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14.25c2.071 0 3.75-1.679 3.75-3.75S14.071 6.75 12 6.75 8.25 8.429 8.25 10.5 9.929 14.25 12 14.25z"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 19.5a5.25 5.25 0 0110.5 0v.75H6.75V19.5z"/>
    </svg>
  );
}
function BookIcon(){
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6 stroke-emerald-700" strokeWidth="1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 5.25h9a3 3 0 013 3v10.5H7.5A3 3 0 014.5 15.75V5.25z"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75V8.25a3 3 0 00-3-3H7.5"/>
    </svg>
  );
}
function AtomIcon(){
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6 stroke-emerald-700" strokeWidth="1.5">
      <circle cx="12" cy="12" r="1.5"/>
      <ellipse cx="12" cy="12" rx="9" ry="4.5"/>
      <ellipse cx="12" cy="12" rx="4.5" ry="9"/>
    </svg>
  );
}
function TrophyIcon(){
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6 stroke-emerald-700" strokeWidth="1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3.75h7.5v3a3.75 3.75 0 003.75 3.75h.75V7.5a3.75 3.75 0 00-3.75-3.75h-8.25A3.75 3.75 0 004.5 7.5v3h.75A3.75 3.75 0 009 6.75v-3z"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14.25v3M7.5 21h9"/>
    </svg>
  );
}
function ClassroomIcon(){
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6 stroke-emerald-700" strokeWidth="1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5v9H3.75z"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 18.75h10.5"/>
    </svg>
  );
}
function HostelIcon(){
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6 stroke-emerald-700" strokeWidth="1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 10.5l8.25-6 8.25 6v9.75H3.75z"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 20.25v-6h4.5v6"/>
    </svg>
  );
}
